import React, { useState } from 'react';
import { USER_addres } from '../../API/API';

/**
 * Кнопка «Войти через Google».
 *
 * Поток идентичен YandexLoginButton:
 *   1. Юзер жмёт кнопку.
 *   2. Запрашиваем у бэка authorize_url с CSRF state.
 *   3. Редирект на accounts.google.com.
 *   4. После авторизации Google редиректит на /auth/google/callback?code&state.
 *   5. GoogleCallback.jsx обменивает code на JWT через бэк и редиректит в /me.
 */
const GoogleLoginButton = ({ disabled, label }) => {
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    const onClick = async () => {
        setBusy(true);
        setErr('');
        try {
            const frontend = window.location.origin;
            const r = await fetch(
                `${USER_addres}/api/v1/users/auth/google/start?frontend=${encodeURIComponent(frontend)}`,
                { method: 'GET' },
            );
            const data = await r.json();
            if (!r.ok || !data.authorize_url) {
                setErr(data.message || 'Не удалось начать вход');
                setBusy(false);
                return;
            }
            window.location.href = data.authorize_url;
        } catch (e) {
            setErr('Сеть недоступна');
            setBusy(false);
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <button
                type="button"
                onClick={onClick}
                disabled={disabled || busy}
                style={{
                    width: '100%',
                    height: 44,
                    marginTop: 10,
                    background: '#fff',
                    color: '#1f1f1f',
                    border: '1px solid #dadce0',
                    borderRadius: 10,
                    fontSize: 15,
                    fontWeight: 500,
                    cursor: (disabled || busy) ? 'not-allowed' : 'pointer',
                    opacity: (disabled || busy) ? 0.6 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 12,
                    transition: 'box-shadow 0.15s ease',
                    fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
                }}
                onMouseOver={(e) => !disabled && !busy && (e.currentTarget.style.boxShadow = '0 1px 3px rgba(60,64,67,.28)')}
                onMouseOut={(e) => (e.currentTarget.style.boxShadow = 'none')}
            >
                <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/>
                    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
                    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                </svg>
                {busy ? 'Открываем Google...' : (label || 'Войти через Google')}
            </button>
            {err && (
                <div style={{ color: '#dc2626', fontSize: 13, marginTop: 6, textAlign: 'center' }}>
                    {err}
                </div>
            )}
        </div>
    );
};

export default GoogleLoginButton;
